"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _reactI18next = require("react-i18next");
var _yup = require("yup");
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Input = _interopRequireDefault(require("../../../../../../../ui/Input"));
var _Select = _interopRequireDefault(require("../../../../../../../ui/Select"));
var _Button = _interopRequireWildcard(require("../../../../../../../ui/Button"));
var _Modal = _interopRequireDefault(require("../../../../../../../Modal"));
var _selectors = require("../../../../../../store/selectors");
var _localization = _interopRequireDefault(require("../../../../../../../../localization"));
var _constants = require("../../constants");
var _selectors2 = require("./store/selectors");
var _styles = _interopRequireDefault(require("./styles"));
var _constant = require("./constant");
var _Preview = _interopRequireDefault(require("./components/Preview"));
var _actions = require("./store/actions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var DEFAULT_TYPE = {
  content: _localization.default.t('SEND_BASKET_MODAL:DEFAULT_TYPE_ITEM_CONTENT'),
  value: 'default'
};
var TYPES_ITEMS = [DEFAULT_TYPE];
var SendBasketModal = function SendBasketModal(_ref) {
  var onClose = _ref.onClose,
    basketID = _ref.basketID;
  var _useTranslation = (0, _reactI18next.useTranslation)(['SEND_BASKET_MODAL', 'VALIDATION_ERRORS']),
    t = _useTranslation.t;
  var loading = (0, _reactRedux.useSelector)(_selectors2.getIsSendingBasketForm);
  var dispatch = (0, _reactRedux.useDispatch)();
  var onSend = function onSend(values) {
    return dispatch((0, _actions.startSendingBasket)(basketID, values));
  };
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return (0, _selectors.getBasketById)(state, {
        basketID: basketID
      });
    }),
    title = _useSelector.title,
    locale = _useSelector.locale;
  return /*#__PURE__*/_react.default.createElement(_Modal.default, {
    closeIcon: true,
    size: _Button.SIZES.MEDIUM,
    onClose: onClose
  }, /*#__PURE__*/_react.default.createElement(_Modal.default.Header, null, t('MODAL_TITLE')), /*#__PURE__*/_react.default.createElement(_Modal.default.Content, null, /*#__PURE__*/_react.default.createElement(_formik.Formik, {
    initialValues: _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _constant.SEND_BASKET_MODAL_FIELDS.EMAIL, ''), _constant.SEND_BASKET_MODAL_FIELDS.TITLE, title), _constant.SEND_BASKET_MODAL_FIELDS.TYPE, DEFAULT_TYPE.value), _constant.SEND_BASKET_MODAL_FIELDS.LOCALE, locale),
    validationSchema: (0, _yup.object)().shape(_defineProperty(_defineProperty({}, _constant.SEND_BASKET_MODAL_FIELDS.EMAIL, (0, _yup.string)().email(t('NOT_CORRECT_EMAIL')).required(t('REQUIRED_FIELD'))), _constant.SEND_BASKET_MODAL_FIELDS.TITLE, (0, _yup.string)().required(t('REQUIRED_FIELD')))),
    onSubmit: function onSubmit(values) {
      onSend(values);
    }
  }, function (_ref3) {
    var handleSubmit = _ref3.handleSubmit,
      values = _ref3.values;
    return /*#__PURE__*/_react.default.createElement("form", {
      action: "#",
      className: _styles.default.sendModal,
      onSubmit: handleSubmit
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.cols
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.leftCol
    }, /*#__PURE__*/_react.default.createElement(_formik.FastField, {
      name: _constant.SEND_BASKET_MODAL_FIELDS.EMAIL,
      render: function render(_ref4) {
        var field = _ref4.field,
          form = _ref4.form;
        var errorMsg = (0, _formik.getIn)(form, "touched.".concat(field.name)) && (0, _formik.getIn)(form, "errors.".concat(field.name));
        return /*#__PURE__*/_react.default.createElement(_Input.default, _extends({}, field, {
          className: _styles.default.formStyle,
          errorMsg: errorMsg,
          hasError: Boolean(errorMsg),
          label: t('EMAIL_CONTROL_LABEL'),
          onChange: function onChange(_, event) {
            field.onChange(event);
          }
        }));
      }
    }), /*#__PURE__*/_react.default.createElement(_formik.FastField, {
      name: _constant.SEND_BASKET_MODAL_FIELDS.TITLE,
      render: function render(_ref5) {
        var field = _ref5.field,
          form = _ref5.form;
        var errorMsg = (0, _formik.getIn)(form, "touched.".concat(field.name)) && (0, _formik.getIn)(form, "errors.".concat(field.name));
        return /*#__PURE__*/_react.default.createElement(_Input.default, _extends({}, field, {
          className: _styles.default.formStyle,
          errorMsg: errorMsg,
          hasError: Boolean(errorMsg),
          label: t('TITLE_CONTROL_LABEL'),
          onChange: function onChange(_, event) {
            field.onChange(event);
          }
        }));
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.rightCol
    }, /*#__PURE__*/_react.default.createElement(_formik.FastField, {
      name: _constant.SEND_BASKET_MODAL_FIELDS.TYPE,
      render: function render(_ref6) {
        var field = _ref6.field,
          form = _ref6.form;
        return /*#__PURE__*/_react.default.createElement(_Select.default, {
          className: _styles.default.formSelect,
          items: TYPES_ITEMS,
          label: t('TYPE_CONTROL_LABEL'),
          value: field.value,
          onChange: function onChange(type) {
            form.setFieldValue(field.name, type);
          }
        });
      }
    }), /*#__PURE__*/_react.default.createElement(_formik.FastField, {
      name: _constant.SEND_BASKET_MODAL_FIELDS.LOCALE,
      render: function render(_ref7) {
        var field = _ref7.field,
          form = _ref7.form;
        return /*#__PURE__*/_react.default.createElement(_Select.default, {
          className: _styles.default.formSelect,
          items: _constants.LANGUAGES_OPTIONS,
          label: t('LOCALE_CONTROL_LABEL'),
          value: field.value,
          onChange: function onChange(newLocale) {
            form.setFieldValue(field.name, newLocale);
          }
        });
      }
    }))), /*#__PURE__*/_react.default.createElement(_Preview.default, {
      basketID: basketID,
      locale: values.locale
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.buttons
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: _styles.default.button,
      size: _Button.SIZES.LARGE,
      onClick: onClose
    }, t('CANCEL_BUTTON')), /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: _styles.default.button,
      loading: loading,
      size: _Button.SIZES.LARGE,
      theme: _Button.THEMES.PURPLE,
      type: "submit"
    }, t('SEND_BUTTON'))));
  })));
};
SendBasketModal.propTypes = {
  basketID: _propTypes.default.number.isRequired,
  onClose: _propTypes.default.func.isRequired
};
var _default = exports.default = (0, _react.memo)(SendBasketModal);